<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

@if (!isLoading && loadingSuccess) {
    <div class="flex flex-col gap-2">
        @if (task.predefined) {
            <div class="flex flex-row p-2 gap-2 bg-slate-100 rounded shadow items-center border" [ngClass]="{ 'border-red-600' : addingScheduleError, 'border-transparent' : !addingScheduleError }">
                <select #predefinedSelect class="p-[5px] rounded-sm shadow-sm bg-white w-[20ch]"  [disabled]="isAddingSchedule">
                    @for (predefinedTask of task.predefined ; track predefinedTask.definitionName) {
                        <option [attr.value]="predefinedTask.definitionName">{{ predefinedTask.definitionName }}</option>
                    }
                </select>
                <div class="w-[3ch] text-center">&#64;</div>
                <div class="flex flex-row gap-1 items-center">
                    <input #cronMinuteInput class="p-1 pt-[6px] pb-[6px] bg-white w-[6ch] text-xs text-center rounded-sm shadow-sm" placeholder="min">
                    <input #cronHourInput class="p-1 pt-[6px] pb-[6px] bg-white w-[6ch] text-xs text-center rounded-sm shadow-sm" placeholder="hour">
                    <input #cronDomInput class="p-1 pt-[6px] pb-[6px] bg-white w-[6ch] text-xs text-center rounded-sm shadow-sm" placeholder="dom">
                    <input #cronMonthInput class="p-1 pt-[6px] pb-[6px] bg-white w-[6ch] text-xs text-center rounded-sm shadow-sm" placeholder="month">
                    <input #cronDowInput class="p-1 pt-[6px] pb-[6px] bg-white w-[6ch] text-xs text-center rounded-sm shadow-sm" placeholder="dow">
                </div>
                <div class="flex flex-row justify-end grow">
                    <button 
                        (click)="onAddSchedule(predefinedSelect.value, cronMinuteInput.value, cronHourInput.value, cronDomInput.value, cronMonthInput.value, cronDowInput.value)" 
                        class="p-1 rounded-sm shadow-sm w-[10ch] bg-white border border-opacity-0 border-ponder-link hover:border-opacity-100 hover:text-ponder-link disabled:text-slate-400 disabled:hover:border-opacity-0" 
                        [disabled]="isAddingSchedule || !cronMinuteInput.value || !cronHourInput.value || !cronDomInput.value || !cronMonthInput.value || !cronDowInput.value">
                        Add
                    </button>
                </div>
            </div>
        } @else {
            <div class="grow text-center text-slate-400 p-2">
                This task has no predefined configurations. Add one above to create a schedule.
            </div>
        }
        @if (taskSchedules?.length) {
            <div class="flex flex-col rounded shadow">
                <table class="table-auto rounded">
                    <thead>
                        <tr class="bg-ponder-light text-slate-50 font-bold text-left">
                            <th class="p-2 pr-6 rounded-tl">Id</th>
                            <th class="p-2 pr-6">Predefined</th>
                            <th class="p-2 pr-6">Cron Schedule</th>
                            <th class="p-2 pr-6">Enabled</th>
                            <th class="p-2 pr-6 rounded-tr text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (taskSchedule of taskSchedules ; track taskSchedule.id) {
                            <tr class="text-xs" [ngClass]="{ 'bg-white' : $even, 'bg-slate-50' : $odd, 'rounded-b' : $last }">
                                <td class="p-2 pr-6" [ngClass]="{ 'rounded-bl' : $last }">{{ taskSchedule.id }}</td>
                                <td class="p-2 pr-6 truncate" title="{{ taskSchedule.definitionName }}">{{ taskSchedule.definitionName }}</td>
                                <td class="p-2 pr-6 font-mono">{{ taskSchedule.cronSchedule }}</td>
                                <td class="p-2 pr-6 text-center">{{ (taskSchedule.enabled ? "✓" : "") }}</td>
                                <td class="p-2 pr-6 flex flex-row gap-1 items-center justify-center" [ngClass]="{ 'rounded-br' : $last }">
                                    @if (taskSchedule.enabled) {
                                        <button (click)="onPauseClicked(taskSchedule)" class="stroke-slate-700 rounded hover:stroke-black hover:bg-sky-200 hover:shadow-sm p-1 disabled:hover:bg-transparent disabled:hover:cursor-default disabled:hover:stroke-slate-400 disabled:stroke-slate-400" [disabled]="isRunningAction">
                                            <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                                                <title>Pause Schedule</title>
                                                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="pauseSvgIcon" />
                                            </svg>
                                        </button>
                                    } @else {
                                        <button (click)="onResumeClicked(taskSchedule)" class="stroke-slate-700 rounded hover:stroke-black hover:bg-green-200 hover:shadow-sm p-1 disabled:hover:bg-transparent disabled:hover:cursor-default disabled:hover:stroke-slate-400 disabled:stroke-slate-400" [disabled]="isRunningAction">
                                            <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                                                <title>Resume Schedule</title>
                                                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="playSvgIcon" />
                                            </svg>
                                        </button>
                                    }
                                    <button (click)="onDeleteClicked(taskSchedule)" class="stroke-slate-700 rounded hover:stroke-black hover:bg-red-200 hover:shadow-sm p-1 disabled:hover:bg-transparent disabled:hover:cursor-default disabled:hover:stroke-slate-400 disabled:stroke-slate-400" [disabled]="isRunningAction">
                                        <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                                            <title>Delete Schedule</title>
                                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="deleteSvgIcon" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        } @else {
            <div class="flex flex-col bg-slate-100 rounded shadow items-center justify-center align-middle">
                <div class="text-slate-400 p-8">This task has no schedules.</div>
            </div>
        }
    </div>
}
<ng-template #confirmationModalTemplate></ng-template>